module.exports = __webpack_public_path__ + "img/group_avatar_guarantee_3.7d98ac24.png";